/* eslint-disable spire/export-styles */
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface Props extends WidgetProps, HasCategoryContext {}

export interface CategoryNameStyles {
    categoryName?: InjectableCss;
}

export const categoryNameStyles: CategoryNameStyles = {
    categoryName: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 28px;
                        `,
                        css`
                            font-size: 28px;
                        `,
                        null,
                        null,
                    ],
                    "minMax",
                );
            }}
        `,
    },
};

const styles = categoryNameStyles;

const CategoryImage: React.FunctionComponent<Props> = ({ category }: Props) => {
    if (!category) {
        return null;
    }

    return (
        <Typography
            variant="h2"
            {...styles.categoryName}
            data-test-selector={`categoryName_${category.shortDescription ?? category.name}`}
        >
            {category.shortDescription ?? category.name}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(CategoryImage),
    definition: {
        group: "Category Details",
        icon: "PageTitle",
    },
};

export default widgetModule;
